// src/constants/env.js

const env = {
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
    REDIRECT_URI: process.env.REACT_APP_REDIRECT_URI,
    API_BASE: process.env.REACT_APP_API_BASE || '', // якщо треба бекенд
};

export default env;

